/*=========================================================================================
  File Name: moduleSpaceMutations.js
  Description: Space Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  CREATE_NOTICE(state, payload) {
    state.notices.unshift(payload)
  },
  UPDATE_NOTICE(state, payload) {
    var index = state.notices.findIndex(function(item){return item.id == payload.id})
    if (index != -1){
      state.notices[index].title = payload.title
      state.notices[index].detail = payload.detail
      state.notices[index].file_names = payload.file_names
      state.notices[index].update_time = payload.update_time
      state.ActiveNotice = state.notices[index]
    }
  },
  UPDATE_NOTICE_TITLE(state, payload) {
    var index = state.notices.findIndex(function(item){return item.id == payload.id})
    state.notices[index].title = payload.title
    state.notices[index].detail = payload.detail
  },
  DELETE_NOTICE(state, payload) {
    var index = state.notices.findIndex(function(item){return item.id == payload})
    if(index != -1){
      state.notices.splice(index,1)
    }
  },
  SET_ACTIVE_NOTICE(state, payload) {
    state.ActiveNotice = payload
  },
  SET_NOTICE_LIST(state, payload){
    if (payload){
      state.notices = payload.sort(function(a,b) {return a.update_time > b.update_time ? -1 : a.update_time > b.update_time ? 1 : 0 })
      state.ActiveNotice = state.notices[0]
    } else {
      state.notices = []
      state.ActiveNotice = {
          title:'공지사항 없음',
          detail:'',
          id:0
      }
    }
  },
  SET_NOTICE_SEARCH_QUERY(state, query) {
      state.noticeSearchQuery = query
  },
}
